var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7-20a6.885,6.885,0,0,0-3.533.933A6.851,6.851,0,0,0,.933-16.5,7.128,7.128,0,0,0,0-12.9,6.933,6.933,0,0,0,1-9.267l5.6,9A.577.577,0,0,0,7.067,0h.067A.577.577,0,0,0,7.6-.267l5.467-9.067a7.248,7.248,0,0,0,.933-3.6,7.065,7.065,0,0,0-.933-3.567,6.851,6.851,0,0,0-2.533-2.567A6.885,6.885,0,0,0,7-20Zm5.067,10-5,8.267L2-9.867a5.942,5.942,0,0,1-.867-3.067,5.77,5.77,0,0,1,.8-2.967,6.042,6.042,0,0,1,2.133-2.167A5.6,5.6,0,0,1,7-18.867a5.6,5.6,0,0,1,2.933.8A6.042,6.042,0,0,1,12.067-15.9a5.77,5.77,0,0,1,.8,2.967,5.6,5.6,0,0,1-.8,2.933ZM7-16.467a3.405,3.405,0,0,0-2.5,1.033,3.367,3.367,0,0,0-1.033,2.467A3.367,3.367,0,0,0,4.5-10.5,3.405,3.405,0,0,0,7-9.467,3.405,3.405,0,0,0,9.5-10.5a3.367,3.367,0,0,0,1.033-2.467A3.367,3.367,0,0,0,9.5-15.433,3.405,3.405,0,0,0,7-16.467ZM7-10.6a2.206,2.206,0,0,1-1.667-.7,2.334,2.334,0,0,1-.667-1.667,2.334,2.334,0,0,1,.667-1.667A2.206,2.206,0,0,1,7-15.333a2.206,2.206,0,0,1,1.667.7,2.334,2.334,0,0,1,.667,1.667A2.334,2.334,0,0,1,8.667-11.3,2.206,2.206,0,0,1,7-10.6Z",
    transform: "translate(0 20)",
    fill: "#c38f51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.56a4ff3fdb6487f524a7c13defced472.svg";
export { ForwardRef as ReactComponent };